<template>
  <div id="contenedor-main-listado-junta-aclaraciones">
    <template v-if="!$vuetify.breakpoint.mobile">
      <desktop></desktop>
    </template>
    <template v-else>
      <mobile></mobile>
    </template>
  </div>
</template>

<script>
import Desktop from './Desktop.vue';
import Mobile from './Mobile.vue';

export default {
  name: 'MainListadoJuntaAclaraciones',
  components: {
    Desktop,
    Mobile,
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss">
</style>
